import { useNavigate } from 'react-router-dom';
import Button from '../../common/Button.js';

export function RecentRecordChip({ title, badge, badgeClass = 'text-orange-500', subtitle, onClick }) {
  return (
    <button
      type="button"
      className="shrink-0 snap-start w-[11.5rem] sm:w-[12.5rem] text-left px-2.5 py-1.5 rounded-lg bg-gray-50 hover:bg-gray-100 border border-gray-100 transition-colors"
      onClick={onClick}
    >
      <div className="flex items-center justify-between gap-1.5">
        <p className="font-medium text-gray-800 text-xs truncate">{title}</p>
        {badge ? (
          <span className={`text-[10px] font-semibold shrink-0 ${badgeClass}`}>{badge}</span>
        ) : null}
      </div>
      {subtitle ? (
        <p className="text-[11px] text-gray-500 mt-0.5 truncate">{subtitle}</p>
      ) : null}
    </button>
  );
}

const RecentRecordStrip = ({ title, viewAllLink, items = [], emptyMsg, renderItem }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 sm:p-4 mb-4">
      <div className="flex items-center justify-between mb-2.5">
        <h2 className="text-sm sm:text-base font-semibold text-gray-800">{title}</h2>
        {viewAllLink ? (
          <Button variant="link" size="sm" onClick={() => navigate(viewAllLink)}>View All →</Button>
        ) : null}
      </div>
      {items.length === 0 ? (
        <p className="text-gray-400 text-sm text-center py-4">{emptyMsg}</p>
      ) : (
        <div className="flex gap-2 overflow-x-auto pb-1 [scrollbar-width:thin] snap-x snap-mandatory">
          {items.map(renderItem)}
        </div>
      )}
    </div>
  );
};

export default RecentRecordStrip;
